import React, { FC, MouseEventHandler, useRef } from 'react'
import classNames from 'classnames'

import { callAll, getStyledElementProps } from '@/utils'
import { Typography, IconMoon } from '@/atoms'
import { Spacer } from '@/layout'
import { AccordeonCardProps, AccordeonCardBodyProps } from '@/types'

import styles from './accordeon-card.module.scss'

export const AccordeonCardBody: FC<AccordeonCardBodyProps> = (props) => {
  const styledProps = getStyledElementProps(props, styles['body'])
  return <div {...styledProps} />
}

export const AccordeonCard: FC<AccordeonCardProps> = ({
  title,
  subtitle,
  variant = 'default',
  image,
  children,
  titleColor,
  subtitleColor,
  expanded = false,
  titleVariant = 'emphasized-1',
  headerWithBorder = false,
  mainWrapperProps = {},
  headerWrapperProps = {},
  alt = '',
  width = '40',
  height = '40',
  loading = 'lazy',
}) => {
  const mainWrapperEl = useRef<HTMLDivElement>(null)
  const handleClick: MouseEventHandler<HTMLDivElement> = () => {
    mainWrapperEl.current?.classList.toggle(styles['expanded'])
  }

  const getHeaderWrapperProps = () => {
    const { onClick, ...props } = headerWrapperProps
    return {
      onClick: callAll(onClick, handleClick),
      ...props,
    }
  }

  const headerStyledProps = getStyledElementProps(
    getHeaderWrapperProps(),
    classNames(styles['header'], {
      [styles['with-border']]: headerWithBorder,
    })
  )

  const styledMainWrapperProps = getStyledElementProps(
    mainWrapperProps,
    classNames(
      {
        [styles['expanded']]: expanded,
      },
      styles[variant]
    )
  )

  return (
    <div
      ref={mainWrapperEl}
      {...styledMainWrapperProps}
      style={{ padding: image ? '12px 12px 0px 12px' : '24px 24px 12px 24px' }}
    >
      <div {...headerStyledProps}>
        {/*<div style={{ width: '90%', marginTop: '5px' }}>*/}
        <div style={{ display: 'flex', gap: '12px', width: '250px' }}>
          {image && (
            <img
              className={styles['image']}
              src={image}
              alt={alt}
              width={width}
              height={height}
              loading={loading}
            />
          )}
          {title && (
            <Typography
              variant={titleVariant}
              tag={'span'}
              typographyColor={titleColor}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {title}
            </Typography>
          )}
        </div>
        {subtitle && (
          <>
            <Spacer variant={'vertical'} size={'2x'} />
            <Typography variant={'body-1'} typographyColor={subtitleColor}>
              {subtitle}
            </Typography>
          </>
        )}
        <IconMoon
          name={'icon-chevron-down'}
          size={'sm'}
          className={styles['caret-icon']}
          style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            color: variant === 'dark' ? '#ffffff' : '#000000',
          }}
        />
      </div>
      {children}
    </div>
  )
}
